import { PlusIcon } from '@langchain/untitled-ui-icons';

import { ReactNode } from 'react';

import { cn } from '@/utils/tailwind';

export interface AlertButtonGroupOption<T extends string> {
  value: T;
  label: string;
  icon?: ReactNode;
}

export function AlertButtonGroup<T extends string>({
  options,
  value,
  onChange,
  stack,
  noDividers,
}: {
  options: AlertButtonGroupOption<T>[];
  value: T;
  onChange: (value: T) => void;
  stack?: boolean;
  noDividers?: boolean;
}) {
  return (
    <div
      className={cn(
        'flex w-fit items-center overflow-hidden text-nowrap rounded-lg border border-primary',
        !stack && 'flex-row',
        stack && `flex-col lg:flex-row`,
        !noDividers && [
          !stack && 'divide-x divide-primary',
          stack && 'divide-y lg:divide-x lg:divide-y-0',
        ]
      )}
    >
      {options.map((option) => (
        <button
          type="button"
          key={option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            'flex w-full items-center gap-2 text-nowrap px-3 py-1 text-sm font-medium transition',
            noDividers
              ? value === option.value
                ? 'rounded-lg bg-tertiary text-primary'
                : 'text-tertiary hover:text-primary'
              : value === option.value
              ? 'rounded-md bg-tertiary text-primary'
              : 'text-tertiary hover:text-primary'
          )}
        >
          {option.icon && option.icon}
          {option.label}
        </button>
      ))}
    </div>
  );
}

export function AlertsCreateButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'flex items-center gap-1 whitespace-nowrap rounded-md border border-secondary px-3 py-1 text-sm font-semibold hover:bg-secondary'
      )}
    >
      <PlusIcon className="h-4 w-4" />
      New Alert
    </button>
  );
}
